import { range } from 'lodash';

export const EARLIEST_TAX_YEAR = 2012;
export const CURRENT_TAX_YEAR = 2025;

export const CALC_BY_ACCOUNT_START_YEAR = 2025;

export const TAX_YEARS: number[] = range(EARLIEST_TAX_YEAR, CURRENT_TAX_YEAR + 4); // +2 includes the current tax year as well as the year after that
